"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCreditCardSolid = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M5.61 52.76a4.89 4.89 0 0 0 4.89 4.89h49a4.89 4.89 0 0 0 4.89-4.89V29.54H5.61zm39.77-5.63h11.14v3H45.38zm-14 0h11.11v3H31.35zM59.5 12.35h-49a4.89 4.89 0 0 0-4.89 4.89v3.89h58.78v-3.89a4.89 4.89 0 0 0-4.89-4.89z"
  })),
  height: undefined,
  width: undefined
});
IconCreditCardSolid.displayName = 'IconCreditCardSolid';
var _default = IconCreditCardSolid;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/credit-card-solid.js
// module id = 154
// module chunks = 0